module.exports = __webpack_public_path__ + "img/palette-2-bg.8dafc87.jpg";